//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/Part.js";
let d=[[],[],[["General","Preferences.GeneralViewPreferences",0],["BaseView","Preferences.BaseViewPreferences",0],["Projected","Preferences.ProjectedViewPreferences",0],["InheritPmi","Preferences.InheritPmiPreferences",0],["Detail","Preferences.DetailViewPreferences",0],["Section","Preferences.SectionViewPreferences",0],["VirtualIntersections","Preferences.VirtualIntersectionsViewPreferences",0],["SmoothEdges","Preferences.SmoothEdgesViewPreferences",0],["VisibleLines","Preferences.VisibleLinesViewPreferences",0],["Threads","Preferences.ThreadsViewPreferences",0],["TraceLines","Preferences.TraceLinesViewPreferences",0],["HiddenLines","Preferences.HiddenLinesViewPreferences",0],["Shading","Preferences.ShadingViewPreferences",0],["FlatPattern","Preferences.FlatPatternViewPreferences",0],["ShipbuildingLines","Preferences.ShipbuildingLinesViewPreferences",0],["ShipDraftingViewLines","Preferences.ShipDraftingViewLinesViewPreferences",0],["ShipGeneralArrangementViewLines","Preferences.ShipGeneralArrangementViewLinesViewPreferences",0]]];
SPLM.Preferences.ViewPreferences = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.ViewPreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;